import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { QcResponseGrid } from 'src/app/shared/models/grid.model';

export const GetFlowsData = createAction('[Flows: Edit Flow]: Get Flows Data');

export const GetFlowsSuccess = createAction(
  '[Flows: Edit Flow]: Get Flows Success',
  props<{ res: QcResponseGrid }>(),
);

export const GetFlowsFailed = createAction(
  '[Flows: Edit Flow]: Get Flows Template Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetFlowsTemplateSuccess = createAction(
  '[Flows: Edit Flow]: Get Flows Template Success',
  props<{ res: QcResponseGrid }>(),
);

export const GetFlowsTemplateFailed = createAction(
  '[Flows: Edit Flow]: Get Flows Template Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetLanguagesSuccess = createAction(
  '[Flows: Edit Flow]: Get Countries Success',
  props<{ res: any[] }>(),
);

export const GetLanguagesFailed = createAction(
  '[Flows: Edit Flow]: Get Countries Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const PanelStatusChanged = createAction('[Flows: Flows Search]: Panel Status Changed');

export const FlowNameChanged = createAction(
  '[Flows: Flows Search]: Flow Name Changed',
  props<{ flowName: string }>(),
);

export const FlowContextChanged = createAction(
  '[Flows: Flows Search]: Flow Context Changed',
  props<{ flowContext: string }>(),
);

export const ActiveFlowsChanged = createAction('[Flows: Flows Search]: Active Flows Changed');

export const DeactivatedFlowsChanged = createAction(
  '[Flows: Flows Search]: Deactivated Flows Changed',
);

export const ClearSearchFlowsOptions = createAction(
  '[Flows: Flows Search]: Clear Search Flows Options',
);

export const DeactivateFlowModal = createAction('[Flows: Flows Search]: Deactivate Flow Modal');

export const DeactivateFlow = createAction('[Flows: Edit Flow]: Deactivate Flow');

export const DeactivateFlowSuccess = createAction('[Flows: Edit Flow]: Deactivate Flow Success');

export const DeactivateFlowFailed = createAction(
  '[Flows: Edit Flow]: Deactivate Flow Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const ActivateFlow = createAction(
  '[Flows: Edit Flow]: Activate Flow',
  props<{ row: any }>(),
);
